module.exports = __webpack_public_path__ + "static/media/thumbs-up.1cfa24a5.png";